module.exports = __webpack_public_path__ + "static/img/name6.f68f2ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/th/name6.png
// module id = xkKY
// module chunks = 1